// Shared props/logic for SettingDesktop and SettingMobile.
// `form` is the parent page's reactive data; fields are edited in place so the
// parent can keep sending its whole state to the API unchanged.
import Accounting from '../partial/accounting'
import pos from '../partial/pos.vue'
import ZibalSettings from './gateway/ZibalSettings'
import ZarinpalSettings from './gateway/ZarinpalSettings'
import KarinaSettings from './gateway/KarinaSettings'
import InvoicePrintSettings from './InvoicePrintSettings'
import CustomerPanelSettings from './CustomerPanelSettings'
import SettingAccountPicker from './SettingAccountPicker'
import filePicker from '../../../components/general/filePicker/index'
import SettingToggleRow from './SettingToggleRow'
import {
  toggleGroups,
  detailFields,
  contactFields,
  modules,
  paymentModules,
  isOn,
  onValue,
  offValue
} from '../settingSchema'

export default {
  components: {
    pos,
    Accounting,
    InvoicePrintSettings,
    CustomerPanelSettings,
    ZibalSettings,
    ZarinpalSettings,
    KarinaSettings,
    filePicker,
    // Settings-local copy; global autocomplete stays untouched
    autocomplete: SettingAccountPicker,
    SettingToggleRow
  },
  props: {
    form: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    investor: { type: Boolean, default: false },
    gold: { type: Boolean, default: false },
    gateway: { type: Boolean, default: false },
    inquiryModes: { type: Array, default: () => [] }
  },
  data: () => ({
    detailFields,
    contactFields,
    modules,
    paymentModules
  }),
  computed: {
    groups () {
      return toggleGroups.map(g => ({
        ...g,
        items: g.items.filter(i => !i.gold || this.gold)
      }))
    }
  },
  methods: {
    enabledCount (group) {
      return group.items.filter(i => isOn(this.form, i)).length
    },
    countLabel (group) {
      return this.enabledCount(group) + '/' + group.items.length
    },
    setAll (group, on) {
      group.items.forEach(i => {
        this.form[i.key] = on ? onValue(i) : offValue(i)
      })
    },
    // Called by the parent after a successful save.
    uploadLogo () {
      const picker = this.$refs.refFilePicker
      if (picker && this.form.imagePicker) picker.create(1)
    }
  }
}
